module.exports = __webpack_public_path__ + "img/logo-new2.dd78bbdb.svg";